<template>
  <div>
    <modal
      size="small"
      :hideCloseButton="closeButton"
      v-if="visible"
      @close-modal="closeModal"
    >
      <div slot="header">
        Deseja revogar este token?
      </div>
      <div class="container" slot="content">
        <p>Digite o nome do token para continuar:</p>
        <p><b>{{ this.token.name }}</b></p>
        <form id="form-token" v-on:submit.prevent="onSubmit">
          <div class="form-box form-creditos">
            <label class="label">NOME</label>
            <input
              maxlength="40"
              type="text"
              name="nome"
              class="field"
              required="required"
              v-model="inputName"
              @keydown="form.errors.data = ''"
              autocomplete="off"
            />
            <button :disabled="submited" type="submit" class="btn danger-background -full _mt">
              <b>Revogar Token</b>
            </button>
          </div>
        </form>
         <span class="Message -fail" v-text="this.form.errors.data"></span>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "token-revoke-modal",
  props: {
    visible: Boolean,
    token: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      inputName: "",
      closeButton: true,
      submited: false,
      form: new Form({})
    };
  },
  methods: {
    onSubmit: function() {
      this.submited = true;

      EventBus.$emit('loading-show');

      axios({
        method: "post",
        url: "api/v1/revogar-token",
        data: {
            nome_informado: this.inputName,
            id: this.token.id
        }
      })
        .then(response => {
          EventBus.$emit('loading-hide');
          window.location.reload();
        })
        .catch(error => {
          this.submited = false;

          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    closeModal: function() {
      this.$emit("closeModal");
    }
  }
};
</script>
